import React from 'react'
import { Pivot, PivotItem } from '@fluentui/react';
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from '../../helpers/HelperMethods';
import EnvironmentsList from '../Administration/PowerPlatform/EnvironmentsList';
import PowerPlatformSolutionsList from '../Administration/PowerPlatform/PowerPlatformSolutionsList';
import PowerPlatformItemsList from '../Administration/PowerPlatform/PowerPlatformItemsList';
import EnvironmentsRolesList from '../Administration/PowerPlatform/EnvironmentsRolesList';

const PowerAppEnvironments = ({defaultEnvironments, parentPivotKey}) => {
    
    const defaultSelectedKey = getPivotItemKeyFromUrl('Details', parentPivotKey);

    return(
        <div style={{backgroundColor: '#F8F8F8', minHeight:'500px', padding:'0px 20px 20px 20px', minWidth:'850px'}}>
            <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl(parentPivotKey)}>
                <PivotItem itemKey='Details' headerText='Details' >
                    <EnvironmentsList defaultEnvironments={defaultEnvironments} filterBy={'owner'} />
                </PivotItem>
                <PivotItem itemKey='Solutions' headerText='Solutions'>
                    <PowerPlatformSolutionsList filterBy={'environmentOwner'} />
                </PivotItem>
                <PivotItem itemKey='AppsAndFlows' headerText='Apps & Flows'>
                    <PowerPlatformItemsList  filterBy={'environmentOwner'} />
                </PivotItem>
                <PivotItem itemKey='Roles' headerText='Roles'>
                    <EnvironmentsRolesList filterBy={'environmentOwner'} />
                </PivotItem>
            </Pivot>
        </div>
    );
    
}

const pivotStyles = {
    root: {
        marginBottom: 20
    },
    linkContent: {
        fontSize: 16,
        flex: 'auto'
    }
}

export default PowerAppEnvironments




// WEBPACK FOOTER //
// ./src/components/ManageCenter/PowerAppEnvironments.js